<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list dense>
      <template v-for="item in displayableItems">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon
        >
          <template v-slot:activator>
            <v-list-item :to="item.link" link>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.link"
            link
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="item.text" :to="item.link" link>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { Role } from "@/router/_helper.js";

export default {
  data: () => ({
    items: [
      {
        icon: "mdi-account-multiple",
        text: "Accounts",
        link: "/accounts",
        meta: { authorize: [Role.Super] },
      },
      { icon: "mdi-home-account", text: "Account Info", link: "/account-info" },
      { icon: "mdi-account-supervisor", text: "Users", link: "/users" },
      {
        icon: "mdi-office-building-marker",
        text: "Locations",
        link: "/locations",
      },
      {
        icon: "mdi-file-word-box",
        text: "Terminologies",
        link: "/terminologies",
      },
      {
        icon: "mdi-account-box",
        text: "Contact Types",
        link: "/contactType",
      },
      { icon: "mdi-application-cog", text: "Options", link: "/options" },
      { icon: "mdi-email", text: "Email Settings", link: "/email-settings" },
    ],
  }),

  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    ...mapGetters("navigation", ["navState"]),
    displayableItems() {
      return this.items.filter((item) => {
        let authorize = null;
        if (item && item.meta) {
          console.log(item);
          authorize = item.meta.authorize;
          console.log(authorize);

          return this.isLoggedIn && this.isAuthorized(authorize);
        } else {
          return true; //include menu withtout authorize filter
        }
      });
    },
  },
  methods: {
    isAuthorized(roles) {
      if (!roles || roles.length < 1) {
        return true;
      }
      if (this.userRoles && this.userRoles.length > 0) {
        return this.userRoles.some((r) => roles.includes(r));
      } else {
        this.addErrorMessage("Unauthorized Access");
        return false;
      }
    },
  },
};
</script>

<style>
</style>